export function flattenObject(obj: object) {
  const flatObject: Record<string, any[] | boolean | string | number | null> = {}

  const flatten = (
    value: Record<string, any> | Array<any> | boolean | number | string | undefined,
    pathParts: string[]
  ) => {
    if (value === undefined) return

    const isNull = value === null
    const isArray = Array.isArray(value)
    const isPojo = !isArray && !isNull && typeof value === 'object'
    const isPrimitive = isNull || ['boolean', 'number', 'string'].includes(typeof value)

    if (isPojo) {
      Object.keys(value).forEach((key) =>
        flatten((value as Record<string, any>)[key], [...pathParts, key])
      )
    } else if (isArray || isPrimitive) {
      flatObject[pathParts.join('.')] = value
    }
  }

  flatten(obj, [])
  return flatObject
}

export function toSearchParams(params: object) {
  const flatParams = flattenObject(params)
  const uriEncoded = Object.keys(flatParams).reduce((encoded, key) => {
    encoded[key] = encodeURI(String(flatParams[key]))
    return encoded
  }, {} as Record<string, string>)
  return new URLSearchParams(uriEncoded)
}
